export interface ProductSearch {
  productId: number;
  price: number;
  discountedPrice: number;
  isPromo: boolean;
  name: string;
  brandId: number;
  brandName: string;
  pointConversionRate?: number;
  images: { sourceSet: string[] }[];
}

export interface ProductSearchAdmin {
  productId: number;
  price: number;
  discountedPrice: number;
  casinoPrice: number;
  description: string;
  isPromo: boolean;
  shipping: number;
  isDropShip: boolean;
  isVelvetGlove: boolean;
  isRegularShip: boolean;
  isTruckShip: boolean;
  isActive: boolean;
  name: string;
  brand: { id: number; name: string };
  category: { id: number; name: string };
  images: { sourceSet: string[] }[];
  estimatedShippingDays: string;
}

interface BaseProductSearchQueryParams {
  keyword?: string;
  categoryIds?: number[];
  brandIds?: number[];
  priceFrom?: number;
  priceTo?: number;
  sortBy?: SortBy;
  isPromo?: boolean;
}

export interface ProductSearchQueryParams extends BaseProductSearchQueryParams {
  offset?: number;
  count?: number;
}

export interface ProductAdminSearchQueryParams extends BaseProductSearchQueryParams {
  page?: number;
  pageSize?: number;
}

export enum SortBy {
  Recommended = 'Recommended',
  Price = 'Price',
  PriceDesc = 'PriceDesc',
  NewArrival = 'NewArrival',
  Random = 'Random',
}
